import { fromJS } from 'immutable';
import { normalize } from 'normalizr';

import { CustomerOption, customerOptionSchema } from '@sophocles/entities/CustomerOption/customerOptionRecord';
import { mapListToRecords, normalizeList } from '@sophocles/entities/entityUtils';
import { addToast } from '@sophocles/features/toast';
import apiClient from '@sophocles/http-common';
import { checkHttpStatus, genericErrorAction } from '@sophocles/utils';

/* Receive Actions */
export const RECEIVE_CUSTOMER_OPTIONS = 'RECEIVE_CUSTOMER_OPTIONS';
export function receiveCustomerOptions(json) {
  return {
    type: RECEIVE_CUSTOMER_OPTIONS,
    customerOptions: mapListToRecords(json, CustomerOption),
  };
}

/* Request Actions */
// starter request
export const REQUEST_CUSTOMER_OPTION = 'REQUEST_CUSTOMER_OPTION';
function requestCustomerOption(customerOption_id) {
  return {
    type: REQUEST_CUSTOMER_OPTION,
    customerOption_id,
  };
}

/* Fetch Actions */
// starter fetch

export function fetchCustomerOption(customerOption_id) {
  return dispatch => {
    dispatch(requestCustomerOption(customerOption_id));
    return apiClient
      .get(`/customeroptions/${customerOption_id}/`)
      .then(checkHttpStatus)
      .then(response => normalizeList(response.data, 'customerOptions', customerOptionSchema))
      .then(json => dispatch(receiveCustomerOptions(json.entities.customerOptions)))
      .catch(error => dispatch(genericErrorAction(error, REQUEST_CUSTOMER_OPTION)));
  };
}

export function fetchRawCustomerOptionForCustomer(customer) {
  return dispatch =>
    apiClient
      .get('/customeroptions/', { params: { customer } })
      .then(checkHttpStatus)
      .then(response => response.data)
      .then(json => fromJS(json.results.size > 0 ? json.results[0] : {}))
      .catch(error => dispatch(genericErrorAction(error, REQUEST_CUSTOMER_OPTION)));
}

/* Edit Actions */
export const EDIT_CUSTOMER_OPTION = 'EDIT_CUSTOMER_OPTION';
export function editCustomerOption(customerOption_id) {
  return {
    type: EDIT_CUSTOMER_OPTION,
    customerOption: customerOption_id,
  };
}

export function patchCustomerOption(customerOption_id, values) {
  return dispatch => {
    dispatch(editCustomerOption(customerOption_id));
    return apiClient
      .patch(`/customeroptions/${customerOption_id}/`, values)
      .then(checkHttpStatus)
      .then(response => normalize(response.data, customerOptionSchema))
      .then(json => {
        dispatch(
          addToast({
            title: 'Success',
            message: 'Customer options updated',
            level: 'success',
            dismissible: true,
          }),
        );
        return dispatch(receiveCustomerOptions(json.entities.customerOptions));
      })
      .catch(error => dispatch(genericErrorAction(error, EDIT_CUSTOMER_OPTION)));
  };
}

/* Create Actions */
export const CREATE_CUSTOMER_OPTION = 'CREATE_CUSTOMER_OPTION';
function sayCreateCustomerOption(values) {
  return {
    type: CREATE_CUSTOMER_OPTION,
    values: values,
  };
}

export function createCustomerOption(values) {
  return dispatch => {
    dispatch(sayCreateCustomerOption(values));
    return apiClient
      .post(`/customeroptions/`, values)
      .then(checkHttpStatus)
      .then(response => normalize(response.data, customerOptionSchema))
      .then(json => dispatch(receiveCustomerOptions(json.entities.customerOptions)))
      .catch(error => dispatch(genericErrorAction(error, CREATE_CUSTOMER_OPTION)));
  };
}

/* Delete Actions */
export const DELETE_CUSTOMER_OPTION = 'DELETE_CUSTOMER_OPTION';
function sayDeleteCustomerOption(customerOption_id) {
  return {
    type: DELETE_CUSTOMER_OPTION,
    customerOption: customerOption_id,
  };
}

export function deleteCustomerOption(customerOption_id) {
  return dispatch =>
    apiClient
      .delete(`/customeroptions/${customerOption_id}/`)
      .then(checkHttpStatus)
      .then(r => dispatch(sayDeleteCustomerOption(customerOption_id)))
      .catch(error => dispatch(genericErrorAction(error, DELETE_CUSTOMER_OPTION)));
}
